export default function displayPrice(
  price: string,
  currencySign: string,
  currencySignBefore: boolean
) {
  if (!price) {
    return '';
  }

  return `${currencySignBefore ? currencySign : ''}${price}${
    !currencySignBefore ? '\u00A0' + currencySign : ''
  }`;
}
